import { CaseGranulometry } from '../../CaseGranulometry';
import { getCaseLevels } from './getCaseLevels';
import { getCaseGranulometryLevelsCount } from './counts/getCaseGranulometryLevelsCount';

export const getCaseLowestLevel = (caseGranulometry: CaseGranulometry) =>
  getCaseLevels(caseGranulometry)[getCaseGranulometryLevelsCount(caseGranulometry) - 1];
